import React from 'react';
import './pgrid.scss'

export default (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  if (cellValue !== undefined) {
    return (
      <span className='projSel'>
      <span>{cellValue}</span>
    </span>
    );
  } else {
    return (
      <img src="https://www.ag-grid.com/example-assets/loading.gif" />
    );
  }
};

